import React, { useEffect, useState } from 'react'
import Switch from "../../../../../../../../../core/Switch"
import Svg from '../../../../../../../../../component/common/Svg'
import Callout from '../../../../../../../../../core/Callout'
import iicon from '../../../../../../../../../assets/images/i-icon.png'
import Input from "../../../../../../../../../core/Inputs/DefaultInput"
import { useDispatch } from 'react-redux'
import { updateQuestion, updateQuestionControl, updateQuestionHint } from '../../../../../../../../../store/actions/qnaBuilderAction'
import { getTokenData } from '../../../../../../../../../store/actions/authAction'
import style from "../../../../../../../../style.module.css";
import { useFormik } from 'formik'
import { useTranslation } from 'react-i18next';

const TextPreview = ({ survey_id, questionId, setIsVisibleCollapse, language_code, questionIndex, isVisibleCollapse, collapseMode, setCollapseMode, collapseModes, question }) => {

    //States
    const options = [
        {
            name: 'Number (range 0 - 100)',
            value: 1,
        },
        {
            name: 'Alpha numeric (max characters 100)',
            value: 2,
        },
        {
            name: 'Text - Single line',
            value: 3,
        }

    ]
      const { t, i18n } = useTranslation();
    
    const [value, setValue] = useState(null)
    const [questionText, setQuestionText] = useState(null)
    const [isTouched, setIsTouched] = useState(false)
    const dispatch = useDispatch()
    const [userId, setuserId] = useState('')

    //Formik
    const initialValues = {
        hint: ''
    }

    const formik = useFormik({
        initialValues: initialValues,
    })

    const {
        values,
        handleChange,
        handleBlur,
        setFieldValue,
    } = formik


    //Functionalities
    const handleViewChange = (mode) => {
        setCollapseMode(mode)
    }

    const handleChangeOpt = (option) => {
        setValue(option)
    }

    const afterSave = () => {
        setCollapseMode(collapseModes.preview)
    }

    const handleSave = (option) => {
        if (value) {
            const payloadOption = {
                qid: questionId,
                qtxt: questionText,
                qtype: 2,
                qopts: {
                    selectedFieldType: value?.value
                },
                qorderno: questionIndex,
                qsection: question.sectionId,
                added_by: userId,
                qsurvey: survey_id,
                language_code: language_code
            }
            dispatch(updateQuestion(payloadOption, afterSave))
        }
    }

    // const handleIsScore = (e) => {
    //     const payload = {
    //         column: e.target.value,
    //         value: (e.target.checked) ? 1 : 0,
    //         question_id: questionId
    //     }
    //     dispatch(updateQuestionControl(payload))
    // }

    const handleCancel = () => {
        setIsVisibleCollapse(false)
        setInitialValue()
    }

    const setInitialValue = () => {
        if (question?.options?.selectedFieldType) {
            setValue(options?.filter((opt) => opt.value === Number(question?.options?.selectedFieldType))[0])
        }
        else {
            setValue(null)
        }
    }

    const handleIsRequired = (e) => {
        const payload = {
            column: e.target.value,
            value: (e.target.checked) ? 1 : 0,
            question_id: questionId
        }
        dispatch(updateQuestionControl(payload))
    }

    const handleUpdateQuestionHint = (id, text) => {
        const payload = {
            language_code: language_code,
            id,
            text
        }
        dispatch(updateQuestionHint(payload))
    }

    const handleBlurQuestionHint = (e, { questionId }, text) => {
        handleBlur(e)
        handleUpdateQuestionHint(questionId, text)
    }


    //Effects
    useEffect(() => {
        if (question) {
            setInitialValue()
            setQuestionText(question?.questionText)
            setFieldValue('hint', question?.questionHint ?? '')
        }
    }, [question])

    useEffect(() => {
        dispatch(getTokenData(setuserId))
    }, [userId, dispatch])

    return (
        <div
            className={`${isVisibleCollapse ? 'show' : ''} accordion-collapse collapse`}
            data-bs-parent="#surveyaccordian">
            <div className="accordion-body">

                {/*Edit Version */}
                {collapseMode === collapseModes?.edit && <div className="editor-wrap">
                    <>
                        {(isVisibleCollapse && collapseMode === collapseModes.edit) && <>
                            <div className="text mb-3">
                                <Input
                                    type="text"
                                    view="outlined"
                                    color="default"
                                    label=""
                                    //placeholder={'Please enter hint'}
                                    value={values.hint}
                                    onClick={((e) => e.stopPropagation())}
                                    fill
                                    name='hint'
                                    onChange={window.modulePermissions.M11.edit == 1 ? handleChange : undefined}
                                    onBlur={window.modulePermissions.M11.edit == 1 ? (e) => { handleBlurQuestionHint(e, question, values.hint) } : undefined}
                                    readOnly={window.modulePermissions.M11.edit != 1}
                                    className={"formsinput " + style.card__exp}
                                />
                            </div>
                        </>
                        }
                    </>
                    <div className='choices-full-width'>
                        <div className='d-flex align-items-center'>
                            <div className="text-section multiple-edit-sec p-0 flex-grow-1">
                                <div className="input-score-wrap">
                                    <div className="input-wrap d-flex flex-wrap align-items-center">
                                        <div className="title">{t('survey.answerBe')}</div>
                                        <div className="choices d-flex align-items-center justify-content-between position-relative">
                                            <div className="dropdown table-dropdown ques-options">
                                                <button className="btn dropdown-tgl" type="button" id="quesoptions"
                                                    data-bs-toggle={window.modulePermissions.M11.edit == 1 ? "dropdown" : undefined} onClick={window.modulePermissions.M11.edit == 1 ? () => setIsTouched(true) : undefined}
                                                    aria-haspopup="true" aria-expanded="false"
                                                    disabled={window.modulePermissions.M11.edit != 1}>
                                                    {value?.name ?? 'Select'}
                                                </button>
                                                <div className="dropdown-menu" aria-labelledby="quesoptions">
                                                    {
                                                        options?.map((opt, index) => {
                                                            return (<span
                                                                className="dropdown-item d-flex align-items-center"
                                                                key={index}
                                                                onClick={() => handleChangeOpt(opt)}
                                                            > {opt.name} </span>)
                                                        })
                                                    }
                                                </div>
                                            </div>
                                            {isTouched && value === null && <div className='validation-msg'>Type is required.</div>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="button-wrap d-flex add-cancel-btn mt-0 ps-3">
                                <div className="action-buttons d-flex">
                                    <button className='btn btn-bordered' onClick={() => handleCancel()}>{t('survey.customVariable.cancel')}</button>
                                    {window.modulePermissions.M11.edit == 1 && <button className='btn btn-primary' onClick={() => handleSave(value)}>{t('survey.builder.save')}</button>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>}

                {/* Preview Wrap */}
                {collapseMode === collapseModes?.preview && <div className='d-flex flex-wrap flex-column question-preview-pg'>
                    <div className="preview-header">
                        <div className="radio-btn-screen d-inline-flex align-items-center justify-content-center">
                            <div className="form-check form-check-inline">
                                <input className="form-check-input" type="radio" name="screenSize" id="Desktop" defaultValue="Desktop" defaultChecked />
                                <label className="form-check-label" htmlFor="Desktop" title="Desktop">
                                    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M12 17H21C22.1046 17 23 16.1046 23 15V5C23 3.89543 22.1046 3 21 3H3C1.89543 3 1 3.89543 1 5V15C1 16.1046 1.89543 17 3 17H12ZM12 17V21M12 21H16M12 21H8" stroke="#0F2744" strokeWidth="1.5" strokeLinecap="round" />
                                    </svg>
                                </label>
                            </div>
                            <div className="form-check form-check-inline">
                                <input className="form-check-input" type="radio" name="screenSize" id="Tablet" defaultValue="Tablet" />
                                <label className="form-check-label" htmlFor="Tablet" title="Tablet">
                                    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M11 18.25C10.5858 18.25 10.25 18.5858 10.25 19C10.25 19.4142 10.5858 19.75 11 19.75V18.25ZM13 19.75C13.4142 19.75 13.75 19.4142 13.75 19C13.75 18.5858 13.4142 18.25 13 18.25V19.75ZM6 1.75H18V0.25H6V1.75ZM19.25 3V21H20.75V3H19.25ZM4.75 21V3H3.25V21H4.75ZM18 22.25H6V23.75H18V22.25ZM11 19.75H13V18.25H11V19.75ZM3.25 21C3.25 22.5188 4.48122 23.75 6 23.75V22.25C5.30964 22.25 4.75 21.6904 4.75 21H3.25ZM19.25 21C19.25 21.6904 18.6904 22.25 18 22.25V23.75C19.5188 23.75 20.75 22.5188 20.75 21H19.25ZM18 1.75C18.6904 1.75 19.25 2.30964 19.25 3H20.75C20.75 1.48122 19.5188 0.25 18 0.25V1.75ZM6 0.25C4.48122 0.25 3.25 1.48122 3.25 3H4.75C4.75 2.30964 5.30964 1.75 6 1.75V0.25Z" fill="#0F2744" />
                                    </svg>
                                </label>
                            </div>
                            <div className="form-check form-check-inline">
                                <input className="form-check-input" type="radio" name="screenSize" id="Mobile" defaultValue="Mobile" />
                                <label className="form-check-label" htmlFor="Mobile" title="Mobile">
                                    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M11 18.25C10.5858 18.25 10.25 18.5858 10.25 19C10.25 19.4142 10.5858 19.75 11 19.75V18.25ZM13 19.75C13.4142 19.75 13.75 19.4142 13.75 19C13.75 18.5858 13.4142 18.25 13 18.25V19.75ZM8 1.75H16V0.25H8V1.75ZM17.25 3V21H18.75V3H17.25ZM6.75 21V3H5.25V21H6.75ZM16 22.25H8V23.75H16V22.25ZM11 19.75H13V18.25H11V19.75ZM5.25 21C5.25 22.5188 6.48122 23.75 8 23.75V22.25C7.30964 22.25 6.75 21.6904 6.75 21H5.25ZM17.25 21C17.25 21.6904 16.6904 22.25 16 22.25V23.75C17.5188 23.75 18.75 22.5188 18.75 21H17.25ZM16 1.75C16.6904 1.75 17.25 2.30964 17.25 3H18.75C18.75 1.48122 17.5188 0.25 16 0.25V1.75ZM8 0.25C6.48122 0.25 5.25 1.48122 5.25 3H6.75C6.75 2.30964 7.30964 1.75 8 1.75V0.25Z" fill="#0F2744" />
                                    </svg>
                                </label>
                            </div>
                            <div className="form-check form-check-inline">
                                <button className="full-screen-btn" title="View full screen">
                                    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M14 18V16C14 14.8954 14.8954 14 16 14H18" stroke="#0F2744" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M9 6L9 8C9 9.10457 8.10457 10 7 10L5 10" stroke="#0F2744" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M5 14L7 14C8.10457 14 9 14.8954 9 16L9 18" stroke="#0F2744" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M18 10L16 10C14.8954 10 14 9.10457 14 8L14 6" stroke="#0F2744" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="flex-grow-1 page-content-wrap d-flex align-items-center">
                        <div className="container">
                            <div className="question-wrapper text-question-wrapper">
                                <div className="heading">
                                    <h3>Q{questionIndex}. {questionText}</h3>
                                </div>
                                <div className="field-wrapper question-text">
                                    <div className="text-field-wrap mb-4">
                                        <Input
                                            type={value?.value === 1 ? 'number' : 'text'}
                                            view='outlined'
                                            dense={false}
                                            color='default'
                                            label=''
                                            placeholder={value?.value === 1 ? 'Number input' : 'Text input'}
                                            success={false}
                                            error={false}
                                            fill={true}
                                            errorHelperText={null}
                                            className={"formsinput"}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>}

                {/* Footer Wrap */}
                <div className="opinion-scale bottom-buttons-wrap bottomBtns d-flex align-items-center justify-content-between">
                    <div className="select-language d-flex align-items-center">
                        <div className="dropdown table-dropdown ques-options">
                            {/* <button className="btn dropdown-tgl" type="button" id="languages" data-bs-toggle="dropdown"
                                aria-haspopup="true" aria-expanded="false">
                                <span className='me-2'>English</span>
                            </button> */}
                            {/* <div className="dropdown-menu" aria-labelledby="languages">
                                <a className="dropdown-item"> English </a>
                                <a className="dropdown-item"> German </a>
                                <a className="dropdown-item"> Spanish </a>
                            </div> */}
                        </div>
                    </div>

                    <div className="accoriancon-right d-flex align-items-center flex-wrap justify-content-end">

                        {collapseMode === collapseModes?.edit && <><div className="action-wrapper d-flex accordianSwitch">
                            < Switch
                                type='dense'
                                color='default'
                                disabled={window.modulePermissions.M11.edit != 1}
                                label={t('survey.required')}

                                fill={false}
                                rtl={false}
                                leftPosition={false}
                                className='SwitchCustom'
                                checked={Number(question?.required) === 1}
                                value={'su_is_required'}
                                onChange={window.modulePermissions.M11.edit == 1 ? handleIsRequired : undefined}
                            />
                        </div>
                            <div className="action-wrapper d-flex accordianSwitch ms-3">
                                {/* < Switch
                                    type='dense'
                                    color='default'
                                    disabled={false}
                                    label='Score'
                                    fill={false}
                                    rtl={false}
                                    leftPosition={false}
                                    className='SwitchCustom'
                                    checked={Number(question?.isScore) === 1}
                                    value={'su_is_score'}
                                    onChange={handleIsScore}
                                /> */}
                                {/* <div className="tooltipInit ms-2 custom-callout-init">
                                    <img src={iicon} alt="info" />
                                    <div className='infobox custom-callout'>
                                        < Callout
                                            type='def'
                                            view='outlined'
                                            color='primary'
                                            title='Score'
                                            icon={<Svg name="primary-info" />}
                                        >
                                            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum eleifend arcu laoreet elit maximus, eu accumsan tortor suscipit.
                                        </Callout >

                                    </div>
                                </div> */}
                            </div></>
                        }

                        {window.modulePermissions.M11.edit == 1 && (
                        <div className="switch-button d-flex align-items-center">
                            <div className="form-check">
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    name={`deletecheck-q${questionId}`}
                                    id={`edit-view-q${questionId}`}
                                    checked={collapseMode === collapseModes.edit}
                                    onChange={() => handleViewChange(collapseModes.edit)}
                                />
                                <label className="form-check-label" htmlFor={`edit-view-q${questionId}`}>
                                {t('survey.builder.edit')}
                                </label>
                            </div>
                            <div className="form-check">
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    name={`deletecheck-q${questionId}`}
                                    id={`preview-view-q${questionId}`}
                                    checked={collapseMode === collapseModes.preview}
                                    onChange={() => handleViewChange(collapseModes.preview)}
                                />
                                <label className="form-check-label" htmlFor={`preview-view-q${questionId}`}>
                                {t('survey.builder.preview')}
                                </label>
                            </div>
                        </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default TextPreview